export default __webpack_public_domain__ + __webpack_public_url__ + __webpack_public_path__ + "static/media/external-theme-bg-h.png?v=439a1af1";